import { parseDate } from "../Util/dateHelpers";

export const PAYOUT_TYPES = {
  STRIPE: "STRIPE",
  MANUAL_PAYPAL: "MANUAL_PAYPAL",
};

export class PartnerPayouts {
  constructor(payoutArr) {
    this.payouts = payoutArr.map((p) => {
        switch (p.type) {
            case PAYOUT_TYPES.STRIPE:
                return new StripePayout(p);
            case PAYOUT_TYPES.MANUAL_PAYPAL:
                return new PaypalManualPayout(p);
            default:
                return null;
      }
    }).filter(x => x !== null);
  }

  getPayoutsSortedByDateDecreasing() {
    return this.payouts.sort((a, b) => b.getInitiatedAt() - a.getInitiatedAt());
  }

  hasManualPaypal() {
    return this.payouts.some(p => p.getType() === PAYOUT_TYPES.MANUAL_PAYPAL);
  }
}

export class StripePayout {
  static PAYOUT_SUCCESS_THRESHOLD = 432000000; // 5 days

  constructor(payout) {
    this.initiatedAt = payout.initiatedAt;
    this.transferId = payout.transferId;
    this.stripeAccountId = payout.stripeAccountId;
    this.amountInCents = payout.amount;
    this.description = payout.description;
  }

  getInitiatedAt() {
    return this.initiatedAt;
  }

  getType() {
    return PAYOUT_TYPES.STRIPE;
  }

  getAmountInUsd() {
    return this.amountInCents / 100;
  }

  getTransferId() {
    return this.transferId;
  }

  getDescription() {
    return this.description;
  }

  isComplete() {
    return new Date().getTime() - parseDate(this.initiatedAt).getTime() >= StripePayout.PAYOUT_SUCCESS_THRESHOLD
  }
}

export class PaypalManualPayout {
  constructor(payout) {
    this.initiatedAt = payout.initiatedAt;
    this.dbId = payout.dbId;
    this.transactionId = payout.transactionId;
    this.amountInCents = payout.amount;
    this.description = payout.description;
    this.status = payout.status;
    this.recipientEmail = payout.recipientEmail;
  }

  getInitiatedAt() {
    return this.initiatedAt;
  }

  getType() {
    return PAYOUT_TYPES.MANUAL_PAYPAL;
  }

  getAmountInUsd() {
    return this.amountInCents / 100;
  }

  getTransferId() {
    return this.transactionId;
  }

  getDescription() {
    return this.description;
  }

  getRecipientEmail() {
    return this.recipientEmail;
  }

  isComplete() {
    return this.status === "SUCCESS";
  }
}
